import { isNotNullish } from '@/utils/typing/is-nullish.predicate';

export function getValueByPath(target: any, path: string): any {
    const keys = typeof path === 'string' ? path.split('.') : [path];
    path = '';
    do {
        path += keys.shift();
        if (isNotNullish(target) && isNotNullish(target[path]) && (typeof target[path] === 'object' || !keys.length)) {
            target = target[path];
            path = '';
        } else if (!keys.length) {
            target = undefined;
        } else {
            path += '.';
        }
    } while (keys.length);

    return target;
}
